module.exports = __webpack_public_path__ + "img/kochav_yes.15d5a042.png";